import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { JourneyDetailsType } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

type JourneyDataQueryOptions = Omit<
  UseQueryOptions<JourneyDetailsType, Error>,
  'queryKey' | 'queryFn'
>;

const useGetJourneyData = (id: string, options: JourneyDataQueryOptions) =>
  useQuery<JourneyDetailsType>({
    ...options,
    queryKey: ['route-detail', id],
    queryFn: async () => {
      const { data } = await axiosInstance.get<JourneyDetailsType>(API_ROUTES.journeyDetails(id));

      return data;
    },
    enabled: !!id && options?.enabled,
    gcTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

export default useGetJourneyData;
